import { SequenceTimerIcon } from 'features/CustomCampaigns/EditCampaign/CampaignFlowIcons'

import styles from './DripDelayNode.module.scss'

const delayUnits = {
  hours: 'Hours',
  days: 'Days'
}

function DripDelayNode({ value, unit, onChange }) {
  const handleValueChange = event => {
    const nextValue = Number(event.target.value)

    if (!Number.isFinite(nextValue) || nextValue < 1) {
      return
    }

    onChange?.(nextValue, unit)
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.icon} aria-hidden="true">
        <SequenceTimerIcon />
      </span>
      <span className={styles.label}>Wait before sending the next message</span>
      <input
        type="number"
        min="1"
        className={styles.valueInput}
        value={value ?? ''}
        onChange={handleValueChange}
        aria-label="Delay before the next message"
      />
      <select
        className={styles.unitSelect}
        value={unit}
        onChange={event => onChange?.(value, event.target.value)}
        aria-label="Delay unit"
      >
        {Object.entries(delayUnits).map(([unitValue, unitLabel]) => (
          <option key={unitValue} value={unitValue}>
            {unitLabel}
          </option>
        ))}
      </select>
    </div>
  )
}

export default DripDelayNode
